import _ from 'lodash'
import { RDataMaterial_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const DataMaterial: Array<RDataMaterial_Type> = require('../json/DataMaterial.json')

export function fetchGazSorted() {
  //  var data = [];
  return fetchGenericSorted(DataMaterial.filter((item: RDataMaterial_Type) => item.material === 'Gaz'))
}

export function fetchGaz(uuid: string): RDataMaterial_Type {
  return fetchGeneric(DataMaterial, uuid)
}

export function fetchDataMaterial(uuid: string): RDataMaterial_Type {
  return fetchGeneric(DataMaterial, uuid)
}

//TUBE
export function fetchDataMaterialByMaterialList(): Array<{
  value: string
  label: string
  children: Array<{ value: string; label: string }>
}> {
  const data: Array<{
    value: string
    label: string
    children: Array<{ value: string; label: string }>
  }> = []
  const materials = _.uniqWith(DataMaterial, (a, b) => a.material === b.material).sort((a, b) => a.material.localeCompare(b.material))
  materials.map((mat: RDataMaterial_Type) => {
    let res2 = fetchGenericSorted(DataMaterial.filter((item: RDataMaterial_Type) => item.material === mat.material))

    data.push({ value: mat.material, label: mat.material, children: res2 })
  })
  return data
}

//TUBE
export function fetchDataMaterialByMaterialListI04CONVVOLNER(): Array<{
  value: string
  label: string
  children: Array<{ value: string; label: string }>
}> {
  const data: Array<{
    value: string
    label: string
    children: Array<{ value: string; label: string }>
  }> = []
  const materials = _.sortedUniqBy(DataMaterial, 'material')

  materials.map((mat: RDataMaterial_Type) => {
    let res2 = fetchGenericSorted(DataMaterial.filter((item: RDataMaterial_Type) => item.material === mat.material))
    if (mat.material !== 'Electrique') {
      data.push({ value: mat.material, label: mat.material, children: res2 })
    }
  })
  return data
}

export function fetchDataMaterialByMaterialListI15SILOBOIS(): Array<{
  value: string
  label: string
}> {
  return fetchGenericSorted(DataMaterial.filter(a => a.material === 'Bois'))
}
